export default __webpack_public_path__ + "static/media/icon-nric.516eec37.svg";